import { __decorate, __metadata } from "tslib";
import { IsUndefinable, LengthWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsDefined, IsEnum, IsNotEmpty, IsOptional, IsString, IsUrl, MaxLength } from 'class-validator';
import { TabsNameEnum, WebMerchantExposeGroup, WidgetsEnum } from '../interface';
export class ReadWebMerchantAppBottomBarTabsOptionsDto {
}
__decorate([
    ApiProperty({ type: () => Boolean }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsBoolean({ always: true }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebMerchantExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadWebMerchantAppBottomBarTabsOptionsDto.prototype, "isEnabled", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsBoolean({ always: true }),
    IsDefined({ always: true }),
    IsUndefinable({ groups: [WebMerchantExposeGroup.PATCH] }),
    __metadata("design:type", Boolean)
], ReadWebMerchantAppBottomBarTabsOptionsDto.prototype, "isEnabledOnLatestVersion", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    IsUrl({ require_host: true }, { always: true }),
    MaxLength(500, { always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantAppBottomBarTabsOptionsDto.prototype, "srcImage", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({
        groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE],
    }),
    IsOptional({ always: true }),
    IsString({ always: true }),
    IsUrl({ require_host: true }, { always: true }),
    MaxLength(500, { always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantAppBottomBarTabsOptionsDto.prototype, "srcImageInactive", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    Expose({
        groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE],
    }),
    IsOptional({ always: true }),
    IsBoolean({ always: true }),
    __metadata("design:type", Boolean)
], ReadWebMerchantAppBottomBarTabsOptionsDto.prototype, "useTintColor", void 0);
__decorate([
    ApiProperty({ type: () => String }),
    Expose({
        groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE],
    }),
    IsNotEmpty({ always: true }),
    IsString({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantAppBottomBarTabsOptionsDto.prototype, "text", void 0);
__decorate([
    ApiProperty({ type: () => String, enum: WidgetsEnum }),
    Expose({
        groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE],
    }),
    IsEnum(TabsNameEnum, { always: true }),
    IsNotEmpty({ always: true }),
    LengthWithLVS(1, 255, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantAppBottomBarTabsOptionsDto.prototype, "name", void 0);
//# sourceMappingURL=ReadWebMerchantAppBottomBarTabsOptionsDto.js.map